<script>
  import Label from "./Label.svelte";
  import Select from "svelte-select";
  import { nanoid } from "nanoid";
  import clsx from "clsx";

  let className = "my-4";
  export { className as class };
  export let label = "Land";
  export let value;
  export let required = false;
  const id = "select-" + nanoid();

  const options = {
    DK: "Dänemark",
    D: "Deutschland",
    FR: "Frankreich",
    GB: "Großbritannien (UK)",
    LU: "Luxemburg",
    A: "Österreich",
    CH: "Schweiz",
    AF: "Afghanistan",
    EG: "Ägypten",
    AL: "Albanien",
    DZ: "Algerien",
    AS: "Amerikanisch-Samoa",
    AD: "Andorra",
    AO: "Angola",
    AI: "Anguilla",
    AQ: "Antarktis",
    AG: "Antigua und Barbuda",
    GQ: "Äquatorialguinea",
    AR: "Argentinien",
    AM: "Armenien",
    AW: "Aruba",
    AZ: "Aserbeidschan",
    ET: "Äthiopien",
    AU: "Australien",
    BS: "Bahamas",
    BH: "Bahrain",
    BD: "Bangladesh",
    BB: "Barbados",
    BE: "Belgien",
    BZ: "Belize",
    BJ: "Benin",
    BM: "Bermuda-Inseln",
    BT: "Bhutan",
    BO: "Bolivien",
    BA: "Bosnien-Herzegowina",
    BW: "Botswana",
    BV: "Bouvet-Insel",
    BR: "Brasilien",
    BN: "Brunei",
    BG: "Bulgarien",
    BF: "Burkina Faso",
    BI: "Burundi",
    CL: "Chile",
    CN: "China",
    CK: "Cook-Inseln",
    CR: "Costa Rica",
    DJ: "Djibouti",
    DM: "Dominica",
    DO: "Dominikanische Republik",
    SV: "El Salvador",
    CI: "Elfenbeinküste",
    EC: "Equador",
    ER: "Eritrea",
    EE: "Estland",
    FK: "Falkland-Inseln (Malvinen)",
    FO: "Färöer-Inseln",
    FJ: "Fidschi",
    FI: "Finnland",
    FX: "Frankreich, Metropolitan",
    TF: "Franz. Südpolarterritorien",
    GF: "Französisch-Guyana",
    PF: "Französisch-Polynesien",
    GA: "Gabun",
    GM: "Gambia",
    GE: "Georgien",
    GH: "Ghana",
    GI: "Gibraltar",
    GD: "Grenada",
    GR: "Griechenland",
    GL: "Grönland",
    GP: "Guadeloupe",
    GU: "Guam",
    GT: "Guatemala",
    GN: "Guinea",
    GW: "Guinea-Bissau",
    GY: "Guyana",
    HT: "Haiti",
    HM: "Heard-, MacDonald-Inseln",
    HN: "Honduras",
    HK: "Hongkong",
    IN: "Indien",
    ID: "Indonesien",
    IQ: "Irak",
    IR: "Iran (Islamische Republik)",
    IE: "Irland",
    IS: "Island",
    IL: "Israel",
    IT: "Italien",
    JM: "Jamaika",
    JP: "Japan",
    YE: "Jemen",
    JO: "Jordanien",
    YU: "Jugoslawien",
    VG: "Jungfern-Inseln (UK)",
    VI: "Jungfern-Inseln (USA)",
    KY: "Kaiman-Inseln",
    KH: "Kambodscha",
    CM: "Kamerun",
    CA: "Kanada",
    CV: "Kapverden",
    KZ: "Kasachstan",
    QA: "Katar",
    KE: "Kenia",
    KG: "Kirgistan",
    KI: "Kiribati",
    CC: "Kokos-Inseln",
    CO: "Kolumbien",
    KM: "Komoren",
    CG: "Kongo",
    CD: "Kongo (Demokratische Republik)",
    KP: "Korea (Demokratische Volksrepublik)",
    KR: "Korea (Republik)",
    HR: "Kroatien",
    CU: "Kuba",
    KW: "Kuwait",
    LA: "Laos",
    LS: "Lesotho",
    LV: "Lettland",
    LB: "Libanon",
    LR: "Liberia",
    LY: "Libyen",
    LI: "Liechtenstein",
    LT: "Litauen",
    MO: "Macão",
    MG: "Madagaskar",
    MW: "Malawi",
    MY: "Malaysia",
    MV: "Malediven",
    ML: "Mali",
    MT: "Malta",
    MA: "Marokko",
    MH: "Marshall-Inseln",
    MQ: "Martinique",
    MR: "Mauretanien",
    MU: "Mauritius",
    YT: "Mayotte",
    MK: "Mazedonien",
    MX: "Mexiko",
    FM: "Mikronesien",
    MD: "Moldawien",
    MC: "Monaco",
    MN: "Mongolei",
    MS: "Montserrat",
    MZ: "Mosambik",
    MM: "Myanmar (Burma)",
    NA: "Namibia",
    NR: "Nauru",
    NP: "Nepal",
    NC: "Neukaledonien",
    NZ: "Neuseeland",
    NI: "Nicaragua",
    NL: "Niederlande",
    AN: "Niederländische Antillen",
    NE: "Niger",
    NG: "Nigeria",
    NU: "Niue",
    MP: "Nordliche Mariannen Insel",
    NF: "Norfolk-Insel",
    NO: "Norwegen",
    OM: "Oman",
    TP: "Ost-Timor",
    TL: "Ost-Timor (Timor-Leste)",
    PK: "Pakistan",
    PS: "Palästina (besetzte Territorien)",
    PW: "Palau",
    PA: "Panama",
    PG: "Papua-Neuguinea",
    PY: "Paraguay",
    PE: "Peru",
    PH: "Philippinen",
    PN: "Pitcairn-Inseln",
    PL: "Polen",
    PT: "Portugal",
    PR: "Puerto Rico",
    RE: "Réunion",
    RW: "Ruanda",
    RO: "Rumänien",
    RU: "Russland (Russiche Föderation)",
    KN: "Saint Kitts und Nevis",
    SB: "Salomon-Inseln",
    ZM: "Sambia",
    WS: "Samoa",
    SM: "SanMarino",
    ST: "SãoTomé und Principe",
    SA: "Saudi-Arabien",
    SE: "Schweden",
    SN: "Senegal",
    CS: "Serbien & Montenegro",
    SC: "Seyschellen",
    SL: "Sierra Leone",
    ZW: "Simbabwe",
    SG: "Singapur",
    SK: "Slowakei",
    SI: "Slowenien",
    SO: "Somalia",
    ES: "Spanien",
    LK: "Sri Lanka",
    SH: "St. Helena",
    LC: "St. Lucia",
    PM: "St. Pierre und Miquelon",
    VC: "St. Vincent und die Grenadinen",
    ZA: "Südafrika",
    SD: "Sudan",
    SR: "Surinam",
    SJ: "Svalbard und Jan Mayen",
    SZ: "Swasiland",
    SY: "Syrien",
    TJ: "Tadschikistan",
    TW: "Taiwan",
    TZ: "Tansania",
    TH: "Thailand",
    TG: "Togo",
    TK: "Tokelau",
    TT: "Trinidad und Tobago",
    TD: "Tschad",
    CZ: "Tschechien",
    TN: "Tunesien",
    TR: "Türkei",
    TM: "Turkmenistan",
    TC: "Turks-, Caicos-Inseln",
    TV: "Tuvalu",
    UM: "Übrige Inseln im Pazifik der USA",
    UG: "Uganda",
    UA: "Ukraine",
    HU: "Ungarn",
    UY: "Uruguay",
    UZ: "Usbekistan",
    VU: "Vanuatu",
    VA: "Vatikanstadt",
    VE: "Venezuela",
    AE: "Vereinigte Arabische Emirate",
    US: "Verinigte Staaten von Amerika",
    VN: "Vietnam",
    WF: "Wallis und Futuna",
    CX: "Weihnachtsinsel (AUS)",
    EH: "Westsahara",
    ZR: "Zaire",
    CY: "Zypern",
  };

  const items = [];
  for (const [key, value] of Object.entries(options)) {
    items.push({ value: key, label: value });
  }
</script>

<div class={clsx(className, "not-prose")}>
  <Label {id} {label} {required} />
  <Select {items} {id} {required} bind:value placeholder="Bitte wählen Sie…" />
</div>
